
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import { saveRewardBankInfo } from '@/service/vioReport'
export default {
components: {
Group,
Cell,
CellBox,
XInput,
XButton
},
data () {
return {
reportId: '',
vioTypeCn: '',
vioAddress: '',
rewardStatus: null,
rewardStatusCn: '',
bankCardNo: '',
bankName: '',
bankAccountName: '',
form: {
bankCardNo: '',
bankName: '',
bankAccountName: ''
}
}
},
computed: {

isWaitFill () {
return String(this.rewardStatus) === '0'
},

isFilled () {
const rs = String(this.rewardStatus)
return rs === '1' || rs === '2'
},
rewardStatusClass () {
const rs = String(this.rewardStatus)
if (rs === '0') return 'reward-wait-fill'
if (rs === '1') return 'reward-wait-grant'
if (rs === '2') return 'reward-granted'
return ''
}
},
created () {
const str = sessionStorage.getItem('reportItem') || '{}'
let item = {}
try {
item = JSON.parse(str)
} catch (e) {
item = {}
}
this.reportId = item.id || this.$route.query.id || ''
this.vioTypeCn = item.vioTypeCn || ''
this.vioAddress = item.vioAddress || ''
const rs = item.rewardStatus
this.rewardStatus = (rs === null || rs === undefined || rs === '') ? null : String(rs)
this.rewardStatusCn = item.rewardStatusCn || ''
this.bankCardNo = item.bankCardNo || ''
this.bankName = item.bankName || ''
this.bankAccountName = item.bankAccountName || ''
},
methods: {
/**
* Luhn 算法校验银行卡号
* @param {string} cardNo
* @returns {boolean}
*/
isValidBankCard (cardNo) {
let sum = 0
let shouldDouble = false
for (let i = cardNo.length - 1; i >= 0; i--) {
let digit = parseInt(cardNo.charAt(i), 10)
if (shouldDouble) {
digit *= 2
if (digit > 9) digit -= 9
}
sum += digit
shouldDouble = !shouldDouble
}
return sum % 10 === 0
},
validate () {
const bankCardNo = String(this.form.bankCardNo || '').trim()
const bankName = String(this.form.bankName || '').trim()
const bankAccountName = String(this.form.bankAccountName || '').trim()
if (!bankCardNo) {
return '请输入银行卡号'
}
if (!/^\d{12,19}$/.test(bankCardNo)) {
return '请输入正确的银行卡号'
}
if (!this.isValidBankCard(bankCardNo)) {
return '请输入正确的银行卡号'
}
if (!bankName) {
return '请输入开户行名称'
}
if (bankName.length > 50) {
return '开户行名称长度不能超过50个字符'
}
if (!bankAccountName) {
return '请输入开户人姓名'
}
if (!/^[\u4e00-\u9fa5·]{2,20}$/.test(bankAccountName)) {
return '请输入正确的开户人姓名'
}
return ''
},
commit () {
const msg = this.validate()
if (msg) {
this.$vux.toast.show({
text: msg,
type: 'warn'
})
return
}
this.$vux.loading.show()
saveRewardBankInfo({
data: {
reportId: Number(this.reportId),
bankCardNo: String(this.form.bankCardNo || '').trim(),
bankName: String(this.form.bankName || '').trim(),
bankAccountName: String(this.form.bankAccountName || '').trim()
}
})
.then((response) => {
this.$vux.loading.hide()
const result = response.data
if (result.code === 200 && result.data) {
this.$vux.toast.show({
text: '提交成功'
})

setTimeout(() => {
this.goback()
}, 1500)
} else {
this.$vux.toast.show({
text: result.msg || '提交失败',
type: 'warn'
})
}
})
.catch((error) => {
this.$vux.loading.hide()
this.$vux.toast.show({
text: error.msg || '提交失败',
type: 'warn'
})
})
},
goback () {
sessionStorage.setItem('currentType', 1)
this.$router.replace({ path: '/vioReportIndex' })
}
}
}



// WEBPACK FOOTER //
// ./src/views/vioReport/RewardBank.vue